var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessOpp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EAC8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2649 26.044V22.4189C41.2649 22.1785 41.1672 21.948 40.9932 21.778C40.8192 21.6081 40.5832 21.5126 40.3371 21.5126H21.7804C21.5343 21.5126 21.2983 21.6081 21.1243 21.778C20.9503 21.948 20.8525 22.1785 20.8525 22.4189V26.044H41.2649Z",
    fill: "#650A9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0977 41.2122H39.5986C39.976 41.2122 40.338 41.1157 40.6049 40.944C40.8718 40.7722 41.0217 40.5393 41.0217 40.2964V27.4749H21.0977V41.2122Z",
    fill: "#650A9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessOpp);
export default __webpack_public_path__ + "static/media/accessOpp.1b8dc3f152c18cab7ff87621beac03f6.svg";
export { ForwardRef as ReactComponent };